import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AccountHttp, AccountService } from './account.service';
import { AuditHttp, AuditService } from './audit.service';
import { ClientHttp, ClientService } from './client.service';
import { HttpService } from './http.service';
import { LovDataHttp, LovDataService } from './lov-data.service';
import { PortalAdminHttp, PortalAdminService } from './portal-admin.service';
import { PortalProductsHttp, PortalProductsService } from './portal-products.service';
import { UsersHttp, UsersService } from './users.service';
import { UtilHttp, UtilService } from './util.service';
import { AdminUsersService, AdminUsersHttp } from './admin-users.service.';
import { PWMUsersService, PWMUsersHttp } from './crm/pwm-users.service';
import { SuperAdminHttp, SuperAdminService } from './super-admin.service';
import { HttpClientModule } from '@angular/common/http';
import { ResearchPortalBdHttp, ResearchPortalBdService } from './research-portal-bd.service';
import { IdleLogoutService } from './idle-logout.service';
@NgModule({
  imports: [CommonModule, HttpClientModule, RouterModule],
  declarations: [],
  providers: [
    HttpService,
    AccountHttp,
    AccountService,
    PortalProductsService,
    PortalProductsHttp,
    LovDataService,
    LovDataHttp,
    UtilService,
    UtilHttp,
    UsersService,
    UsersHttp,
    AdminUsersService,
    PWMUsersService,
    AdminUsersHttp,
    PWMUsersHttp,
    PortalAdminService,
    PortalAdminHttp,
    ResearchPortalBdService,
    ResearchPortalBdHttp,
    AuditService,
    AuditHttp,

    ClientService,
    ClientHttp,

    SuperAdminHttp,
    SuperAdminService,
    IdleLogoutService,
  ],
})
export class ServicesModule {}

export { AccountService };
